export default {
  title: 'Miesięczne zestawienia',
  list: {
    empty_list: {
      title: 'Brak miesięcznych zestawień.',
    },
    fields: {
      month: 'Miesiąc',
      stripe_service_invoice_url: 'Faktura Stripe',
      paypal_service_invoice_url: 'Faktura PayPal',
    },
    button: {
      title: 'Eksportuj',
    },
  },
  export_modal: {
    title: 'Eksportuj',
    start_date: {
      title: 'Data początkowa',
      placeholder: 'data',
    },
    end_date: {
      title: 'Data końcowa',
      placeholder: 'data',
    },
    button: {
      export: 'Eksportuj',
      close: 'Zamknij',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
